'use client';
import { Spinner } from '@efcloud/ef-fabric';
import { ComponentProps } from 'react';

import * as S from './loading.styled';

interface Props {
  msg?: string;
  size?: ComponentProps<typeof Spinner>['size'];
}

const LoadingMessage = ({ msg, size }: Props) => (
  <S.Container>
    <Spinner size={size ?? 32} variant="light" aria-label="loading" aria-busy="true" />
    {msg && <S.Message variant="UILabelSmall">{msg}</S.Message>}
  </S.Container>
);

export default LoadingMessage;
